import { Component, OnInit, Input } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { MediaObserver, MediaChange } from '@angular/flex-layout';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {

  showLogo: boolean = true;

  @Input() sidenav: MatSidenav;

  constructor(private watcher: MediaObserver) { }

  ngOnInit() {

    if (this.watcher.isActive('xs') || this.watcher.isActive('sm')) {
      this.showLogo = true;
    }

    this.watcher.media$
      .subscribe((change: MediaChange) => {
        switch (change.mqAlias) {
          case 'xs':
          case 'sm':
            this.showLogo = true;
            break;
          default:
            this.showLogo = !this.sidenav.opened;
            break;
        }
      });

  }

}
